export namespace ParkingaboDisplayPriority {
    export const landscapeOverlay = 9900;
}
